import { ApplicationConfig, provideZoneChangeDetection, APP_INITIALIZER, ErrorHandler, inject } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { routes } from './app.routes';
import { authInterceptor } from './auth/auth.interceptor';
import { WorkspaceValidatorService } from './core/workspace-validator.service';
import { GlobalErrorHandler } from './core/global-error.handler';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideHttpClient(withInterceptors([authInterceptor])),
    provideAnimationsAsync(),
    { provide: ErrorHandler, useClass: GlobalErrorHandler },
    {
      provide: APP_INITIALIZER,
      useFactory: () => {
        const validator = inject(WorkspaceValidatorService);
        return () => validator.validate();
      },
      multi: true,
    },
  ],
};
